import React from "react";
import { Jumbotron } from "react-bootstrap";

function Contact() {
    return (
        <div>
            <Jumbotron id="contact">
                <h1>
                    Contact
                </h1>
            </Jumbotron>
        </div>
    )
}

export default Contact;